import React from 'react';

const Stats = () => {
  const statsData = [
    {
      number: '15+',
      label: 'Produk UMKM',
      icon: '🛍️',
      description: 'Berbagai produk unggulan desa',
      gradient: 'from-purple-500 to-pink-500',
      delay: '0s'
    },
    {
      number: 'Rp 125 Jt',
      label: 'Omzet Bulanan',
      icon: '💰',
      description: 'Pendapatan rata-rata per bulan',
      gradient: 'from-green-500 to-blue-500',
      delay: '0.1s'
    },
    {
      number: '47',
      label: 'Transaksi',
      icon: '📊',
      description: 'Jumlah transaksi bulan ini',
      gradient: 'from-orange-500 to-red-500',
      delay: '0.2s'
    },
    {
      number: '1.2K+',
      label: 'Pengunjung',
      icon: '👥',
      description: 'Total pengunjung platform',
      gradient: 'from-cyan-500 to-blue-500',
      delay: '0.3s'
    }
  ];

  return (
    <section className="py-16 md:py-20 bg-gradient-to-br from-gray-50 to-blue-50 relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center bg-white rounded-full px-4 py-2 shadow-lg mb-4 md:mb-6">
            <span className="w-2 h-2 bg-blue-500 rounded-full mr-2 animate-pulse"></span>
            <span className="text-gray-700 text-sm font-semibold">TRANSFORMASI DIGITAL</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4 md:mb-6">
            BUMDES dalam <span className="text-gradient">Angka</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed px-4">
            Bukti nyata kontribusi BUMDES dalam memajukan perekonomian desa melalui inovasi digital
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {statsData.map((stat, index) => (
            <div 
              key={index}
              className="group relative animate-slide-up"
              style={{animationDelay: stat.delay}}
            >
              <div className="relative bg-white rounded-2xl p-4 md:p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:-translate-y-1">
                {/* Icon */}
                <div className={`w-12 h-12 md:w-16 md:h-16 bg-gradient-to-r ${stat.gradient} rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg`}>
                  <span className="text-lg md:text-xl text-white">{stat.icon}</span>
                </div>
                
                {/* Number */}
                <div className={`text-2xl md:text-3xl font-bold bg-gradient-to-r ${stat.gradient} bg-clip-text text-transparent mb-2 text-center`}>
                  {stat.number}
                </div>
                
                {/* Label */}
                <div className="text-base md:text-lg font-semibold text-gray-800 mb-2 text-center">
                  {stat.label}
                </div>
                
                {/* Description */}
                <p className="text-gray-600 text-sm text-center leading-relaxed">
                  {stat.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-12 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 sm:space-x-6 bg-white/80 backdrop-blur-sm rounded-2xl px-6 py-4 shadow-lg border border-gray-200">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-green-400 rounded-full animate-pulse"></div>
              <span className="text-gray-700 font-semibold text-sm md:text-base">📈 Pertumbuhan 45% YoY</span>
            </div>
            <div className="hidden sm:block w-px h-6 bg-gray-300"></div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-blue-400 rounded-full animate-pulse"></div>
              <span className="text-gray-700 font-semibold text-sm md:text-base">⭐ Terpercaya 500+ Warga</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;